import { observable } from 'mobx';
import { State, ready } from './Types';

class DateTimeTimeZoneInputStore {
  @observable
  state: State = ready();
}

export default DateTimeTimeZoneInputStore;
